import { createTheme } from '@mui/material/styles';
import shippoTheme from '../styles/shippoTheme.js';

const boxTheme = createTheme(shippoTheme, {});

export { boxTheme as default };
//# sourceMappingURL=Box.theme.js.map
